const PACKAGE_TYPE = {
	receive:"RECEIVE",
	send:"SEND"
}

const DATA_ElEMENT_TYPE = {
	send: "SEND",
	receiver_send: "RECEIVER_SEND",
	receive: "RECEIVE"
}

export {PACKAGE_TYPE, DATA_ElEMENT_TYPE}
